// extracted by mini-css-extract-plugin
module.exports = {"pageName":"KitchenForecast_pageName__Iav5M"};